import { createApi } from '@reduxjs/toolkit/query/react';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { baseQueryWithAuth } from '../auth';
import { APIVersion } from '../../constants/keys';
import { CropApi } from '../../types';

const transformErrorResponse = (response: FetchBaseQueryError) =>
  (response as { data?: { errors?: unknown } }).data?.errors;

interface GetCropsResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: CropApi[];
}

// Catalog
export const catalogApi = createApi({
  reducerPath: 'catalogApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getCrops: builder.query<CropApi[], void>({
      query: () => ({
        url: `/catalog-api/${APIVersion}/crops`,
      }),
      transformResponse: (data: GetCropsResponse) => data.results,
      transformErrorResponse,
    }),
  }),
});

export const { useGetCropsQuery } = catalogApi;
